const app = {
  state: {
    breadcrumb: {}, //面包屑导航
    desensitizationName: localStorage.getItem('SET_desensitizationName') == 'true' ? true : false,//姓名脱敏
    desensitizationPhone: localStorage.getItem('SET_desensitizationPhone') == 'true' ? true : false,//手机号脱敏
  },
  mutations: {
    SET_BREADCRUMB: (state, breadcrumb) => {
      state.breadcrumb = breadcrumb
    },
    SET_desensitizationName: (state, onoff) => {
      state.desensitizationName = onoff
    },
    SET_desensitizationPhone: (state, onoff) => {
      state.desensitizationPhone = onoff
    },
  },
  actions: {
    SET_BREADCRUMB({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET_BREADCRUMB')
        resolve()
      })
    },
    SET_desensitizationName({commit}, onoff) {
      localStorage.setItem('SET_desensitizationName', onoff)
      commit('SET_desensitizationName', onoff)
    },
    SET_desensitizationPhone({commit}, onoff) {
      localStorage.setItem('SET_desensitizationPhone', onoff)
      commit('SET_desensitizationPhone', onoff)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js